import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

export const Container = styled.div`
  background: ${buildColor("white", 100)};
  padding-bottom: 12px;
`;

export const PicksWrapper = styled.div`
  padding: 0 16px;
`;

export const NumberFirePredictions = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SmartPlays = styled.div`
  display: flex;
  color: black;
  margin: 12px 16px 6px 16px;
  padding-bottom: 6px;
  font-size: 10px;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid ${buildColor("grey", "L4")};
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  color: ${buildColor("grey", 800)};
  font-family: ${fontCondensed};
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 400;
`;

export const NumberFireIcon = styled.div`
  margin-right: 3px;
  display: flex;
  margin-bottom: -1px;
`;
